import addresses from '1stdibs-contracts/addresses.json';

const V1Addresses = addresses.FirstDibsToken;
const V2Addresses = addresses.FirstDibsTokenV2;

type V1AddressType = keyof typeof V1Addresses;
type V2AddressType = keyof typeof V2Addresses;

const contractV1Addresses = Object.keys(V1Addresses).map(network =>
    V1Addresses[network as V1AddressType].address?.toLowerCase()
);

const contractV2Addresses = Object.keys(V2Addresses).map(network =>
    V2Addresses[network as V2AddressType].address?.toLowerCase()
);

export const isFirstDibsTokenContract = (contractAddress?: string | null): boolean => {
    if (!contractAddress) {
        return false;
    }
    return (
        contractV1Addresses.includes(contractAddress?.toLowerCase()) ||
        contractV2Addresses.includes(contractAddress?.toLowerCase())
    );
};
